import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import PublicQRView from "../components/container/PublicQRView";
import WebBillPayment from "../components/container/WebBillPayment";
import CoinAnimationScreen from "../components/container/CoinAnimationScreen";
import Offline from "../components/container/Offline";
import DataRestore from "../components/container/DataRestore";
import { Menu, UnAuthenticateRoute } from "../components/common";
import MarketplaceRoute from "../components/common/MarketplaceRoute";
import Saddar from "../components/Features/Saddar";
import OrderManagement from "../components/Features/OrderManagement";
import OrderManagementDetail from "../components/Features/OrderManagement/OrderManagementDetail";
import StockManagement from "../components/Features/StockManagement";
import CreateStockWrapper from "../components/Features/StockManagement/CreateStockWrapper";
import ViewLedger from "../components/Features/ViewLedger";
import UCash from "../components/Features/UCash";
import SaleBook from "../components/Features/SaleBook";
import OrderSummay from "../components/Features/SaleBook/OrderSummay";
import EnhancedCreateInvoice from "../components/Features/NewInvoiceBook/InvoiceBookPages/CreateInvoice/EnhanceCreateInvoice";
import EnhancePaymentSuccess from "../components/Features/SaleBook/PaymentSuccess/EnhancePaymentSuccess";
import NewStockBook from "../components/Features/NewStockBook";

import EnhanceEditStockItem from "../components/container/NewStockBook/EditStockItem/EnhanceEditStockItem";
import Pincode from "../components/Features/Pincode";
import SignUp from "../components/container/NewSignUp/index";
import CreateBusiness from "../components/container/CreateBusiness";
import CompleteOnboarding from "../components/container/CompleteOnboarding";
import Account from "../components/Features/Account";
import { AccountDetail } from "../components/container/Account";
import TransactionForm from "../components/container/Account/TransactionForm";
import ContactForm from "../components/container/Account/ContactForm";
import EnhancedItemReport from "../components/container/NewStockBook/StockbookReport/ItemReport/EnhanceItemReport";
import Sales from "../components/Features/Sales";
import ExpenseForm from "../components/container/Expense/ExpenseForm";
import LoadMoney from "../components/container/Ucash/LoadMoney";
import ShowQR, { ALL_SHOW_QR_ACTIONS } from "../components/common/ShowQR";
import PendingPaymentCollection from "../components/container/Ucash/PendingPaymentCollection";
import AllTransaction from "../components/container/Ucash/AllTransaction";
import Easyload from "../components/container/Ucash/Easyload";
import BillPayments from "../components/container/Ucash/BillPayments";
import SellVouchers from "../components/container/Ucash/SellVouchers";
import SendMoney from "../components/container/Ucash/SendMoney";
import SendMoneyTransactionSuccess from "../components/container/Ucash/SendMoney/SendMoneyTransactionSuccess";
import EnhancementRequestMoney from "../components/container/Ucash/RequestMoney/EnhancementRequestMoney";
import EasyloadTransactionSuccess from "../components/container/Ucash/Easyload/EasyloadTransactionSuccess";
import BillTransactionSuccess from "../components/container/Ucash/BillPayments/BillTransactionSuccess";
import VouchersTransactionSuccess from "../components/container/Ucash/SellVouchers/VouchersTransactionSuccess";
import VerifyPin from "../components/container/Ucash/VerifyPin";
import QuickSaleForm from "../components/container/QuickSale/QuickSaleForm";
import QuickSale from "../components/Features/QuickSale";
import CashBook from "../components/Features/CashBook";
import MoneyIn from "../components/container/CashBook/MoneyIn";
import MoneyOut from "../components/container/CashBook/MoneyOut";
import POSLayout from "../components/Features/POSLayout";
import SaleInvoice from "../components/Features/SaleInvoice";
import QuickExpenses from "../components/Features/QuickExpenses";
import PurchaseOrders from "../components/Features/PurchaseOrders";
import BusinessOverview from "../components/Features/BusinessOverview";
import ProfitAndLoss from "../components/container/BusinessOverview/ProfitAndLoss";
import CategorizedList from "../components/container/BusinessOverview/CategorizedList";
import BusinessOverviewTransactions from "../components/Features/BusinessOverviewTransactions";
import CashFlow from "../components/container/BusinessOverview/CashFlow";
import Printer from "../components/Features/Printer";
import Profile from "../components/Features/Profile";
import BackupData from "../components/Features/BackupData";
import { CreateAndEditBusiness } from "../components/Features/CreateAndEditBusiness";
import ForgetPin from "../components/container/NewSignUp/ForgotPin";
import TransactionSuccess from "../components/Features/TransactionSuccess";
import NotFound from "../components/Features/NonFound";
import AccountLimit from "../components/container/Ucash/AccountLimit";
import WalletOnboarding from "../components/container/Ucash/WalletOnboarding";
import ViewBankStatement from "../components/container/Ucash/AllTransaction/ViewBankStatment";
import CustomStatement from "../components/container/Ucash/AllTransaction/CustomStatement";
import BillTransactionListing from "../components/container/Ucash/BillPayments/BillTransactionListing";
import VoucherTransactionListing from "../components/container/Ucash/SellVouchers/VoucherTransactionListing";
import EasyloadTransactionListing from "../components/container/Ucash/Easyload/EasyloadTransactionListing";
import TransactionDetail from "../components/container/Ucash/TransactionDetail";
import Reports from "../components/container/Reports";
import WalletAccountDetail from "../components/container/Ucash/WalletAccountDetail";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* UnAuthenticated */}
      <Route element={<UnAuthenticateRoute />}>
        <Route path="/" element={<SignUp />} />
        <Route exact path="/SignUp" element={<SignUp />} />
        <Route exact path="/CreateBusiness" element={<CreateBusiness />} />
        <Route exact path="/dataRestore" element={<DataRestore />} />
        <Route exact path="/ForgotPin" element={<ForgetPin />} />
      </Route>

      {/* Authenticated */}
      <Route element={<Menu />}>
        <Route exact path="/VerifyPin" element={<VerifyPin />} />
        <Route path="/" element={<Account />} />
        <Route exact path={"/Accounts"} element={<Account />} />
        <Route exact path={"/UdhaarBook"} element={<Account />} />
        <Route
          exact
          path="/Accounts/AccountDetail/:id"
          element={<AccountDetail />}
        />
        <Route
          exact
          path="/Accounts/TransactionForm/:id"
          element={<TransactionForm />}
        />
        <Route
          exact
          path="/Accounts/TransactionForm/Edit/:txnsId"
          element={<TransactionForm />}
        />
        <Route exact path="/Accounts/ContactForm" element={<ContactForm />} />
        <Route
          exact
          path="/Accounts/ContactForm/Edit/:id"
          element={<ContactForm />}
        />

        <Route
          exact
          path="/CompleteOnboarding"
          element={<CompleteOnboarding />}
        />
        <Route element={<MarketplaceRoute />}>
          <Route exact path="/Saddar" element={<Saddar />} />
          <Route exact path="/SaddarOrders" element={<OrderManagement />} />
          <Route
            exact
            path="/SaddarOrders/:id"
            element={<OrderManagementDetail />}
          />
          <Route
            exact
            path="/SaddarOrders/returns/:id"
            element={<OrderManagementDetail />}
          />
          <Route exact path="/SaddarInventory" element={<StockManagement />} />
          <Route
            exact
            path="/SaddarInventory/StockDetail/:id"
            element={<CreateStockWrapper />}
          />
          <Route
            exact
            path="/SaddarInventory/CreateStock"
            element={<CreateStockWrapper />}
          />
          <Route
            exact
            path="/SaddarInventory/EditStock/:id"
            element={<CreateStockWrapper />}
          />
          <Route exact path="/ViewLedger" element={<ViewLedger />} />
        </Route>

        <Route exact path="/Sales" element={<Sales />} />
        <Route exact path="/Sales/QuickSale" element={<QuickSale />} />
        <Route exact path="/Sales/CashBook" element={<CashBook />} />
        <Route exact path="/Sales/CashBook/CashIn" element={<MoneyIn />} />
        <Route
          exact
          path="/Sales/CashBook/CashIn/Edit/:id"
          element={<MoneyIn />}
        />
        <Route exact path="/Sales/CashBook/CashOut" element={<MoneyOut />} />
        <Route
          exact
          path="/Sales/CashBook/CashOut/Edit/:id"
          element={<MoneyOut />}
        />
        <Route exact path="/POS" element={<POSLayout />} />
        <Route exact path="/Sales/SaleInvoice" element={<SaleInvoice />} />
        <Route exact path="/Expenses" element={<QuickExpenses />} />
        <Route exact path="/PurchaseOrders" element={<PurchaseOrders />} />

        <Route
          exact
          path="/InvoiceBook/Create"
          element={<EnhancedCreateInvoice />}
        />
        <Route
          exact
          path="/InvoiceBook/Edit"
          element={<EnhancedCreateInvoice />}
        />
        <Route
          exact
          path="/PurchaseInvoice/Create"
          element={<EnhancedCreateInvoice />}
        />
        <Route
          exact
          path="/PurchaseInvoice/Edit"
          element={<EnhancedCreateInvoice />}
        />

        <Route exact path="/UCash" element={<UCash />} />
        <Route exact path="/WalletOnboarding" element={<WalletOnboarding />} />
        <Route exact path="/UCash/LoadMoney" element={<LoadMoney />} />
        <Route
          exact
          path="/UCash/ShowQR"
          element={<ShowQR actionButtons={ALL_SHOW_QR_ACTIONS} />}
        />
        <Route
          exact
          path="/UCash/RequestMoney"
          element={<EnhancementRequestMoney />}
        />
        <Route exact path="/UCash/SendMoney" element={<SendMoney />} />
        <Route
          exact
          path="/UCash/TransactionSuccess/:id"
          element={<SendMoneyTransactionSuccess />}
        />

        <Route exact path="/UCash/Easyload" element={<Easyload />} />
        <Route exact path="/UCash/EasyloadTransactions" element={<EasyloadTransactionListing />} />
        <Route
          exact
          path="/UCash/Easyload/TransactionSuccess/:id"
          element={<EasyloadTransactionSuccess />}
        />
        <Route exact path="/UCash/BillPayments" element={<BillPayments />} />
        <Route exact path="/UCash/BillTransactions" element={<BillTransactionListing />} />
        <Route
          exact
          path="/UCash/BillPayments/TransactionSuccess/:id"
          element={<BillTransactionSuccess />}
        />

        <Route exact path="/UCash/Vouchers" element={<SellVouchers />} />
        <Route exact path="/UCash/VoucherTransactions" element={<VoucherTransactionListing />} />
        <Route
          exact
          path="/UCash/Vouchers/TransactionSuccess/:id"
          element={<VouchersTransactionSuccess />}
        />

        <Route exact path="/UCash/TransactionDetail/:type/:id" element={<TransactionDetail />} />
        <Route
          exact
          path="/UCash/PendingPaymentCollection"
          element={<PendingPaymentCollection />}
        />
        <Route
          exact
          path="/UCash/AllTransaction"
          element={<AllTransaction />}
        />
        <Route exact path="/UCash/VerifyPin" element={<VerifyPin />} />
        <Route exact path="/UCash/AccountLimit" element={<AccountLimit />} />
        <Route exact path="/Ucash/ViewBankStatement" element={<ViewBankStatement />} />
        <Route exact path="/Ucash/CustomStatement" element={<CustomStatement />} />
        <Route exact path="/Ucash/AccountDetail" element={<WalletAccountDetail />} />
        <Route exact path="/SaleBook" element={<SaleBook />} />

        <Route exact path="/SaleBook/OrderSummary" element={<OrderSummay />} />
        <Route
          exact
          path="/SaleBook/PaymentSuccess/:transaction_id"
          element={<EnhancePaymentSuccess />}
        />
        <Route exact path="/Inventory" element={<NewStockBook />} />
        <Route
          exact
          path="/Inventory/Create"
          element={<EnhanceEditStockItem />}
        />
        <Route
          exact
          path="/Inventory/Edit/:id"
          element={<EnhanceEditStockItem />}
        />
        <Route
          exact
          path="/Inventory/Edit"
          element={<EnhanceEditStockItem />}
        />
        <Route
          exact
          path="/Inventory/ItemReport/:id"
          element={<EnhancedItemReport />}
        />

        <Route exact path="/Pincode" element={<Pincode />} />
        <Route exact path="/Printer" element={<Printer />} />
        <Route exact path="/Profile" element={<Profile />} />

        <Route exact path="/Profile/Edit" element={<CreateAndEditBusiness />} />

        <Route exact path="/CreateBusinessForm" element={<CreateBusiness />} />
        <Route exact path="/Backup" element={<BackupData />} />

        <Route exact path="/Expense/ExpenseForm" element={<ExpenseForm />} />
        <Route
          exact
          path="/Expense/ExpenseForm/Edit/:id"
          element={<ExpenseForm />}
        />
        <Route
          exact
          path="/QuickSale/QuickSaleForm"
          element={<QuickSaleForm />}
        />
        <Route
          exact
          path="/QuickSale/QuickSaleForm/Edit/:id"
          element={<QuickSaleForm />}
        />
        <Route exact path="/BusinessOverview" element={<BusinessOverview />} />
        <Route
          exact
          path="/BusinessOverviewTransactions"
          element={<BusinessOverviewTransactions />}
        />
        <Route exact path="/ProfitAndLoss" element={<ProfitAndLoss />} />
        <Route exact path="/CashFlow" element={<CashFlow />} />
        <Route exact path="/CategorizedList" element={<CategorizedList />} />
        <Route
          exact
          path="/TransactionSuccess/:id"
          element={<TransactionSuccess />}
        />
        <Route path="/Reports/*" element={<Reports />} />
      </Route>
      <Route exact path="/qr/:id" element={<PublicQRView />} />
      <Route exact path="/WebBillPayment" element={<WebBillPayment />} />
      <Route exact path="/CoinAnimation" element={<CoinAnimationScreen />} />
      <Route path="*" element={<NotFound />} />
    </Route>,
  ),
);
export default function AppRoutes({ isOffline }) {
  return isOffline ? <Offline /> : <RouterProvider router={router} />;
}
